export default "__VITE_ASSET__D6fWh8ju__"